import { accountApi } from "../config/apiConfig";

export const getCochargeUserByEmaid = async (emaid) => {
  if (!emaid) {
    console.error("No user emaid provided to getCochargeUserByEmaid");
    return null;
  }

  try {
    const response = await accountApi.get(`users/${emaid}`);
    if (response?.status === 401 || response?.status === 402) {
      console.error(
        "Logged user does not have permission to view app users. Please ensure logged user is admin or has the permission read:users",
      );
    }

    const data = response?.data;
    return (Array.isArray(data) ? data[0] : data) || null;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getCochargeUsersByEmail = async (email) => {
  if (!email) {
    console.error("No email provided to getCochargeUsersByEmail");
    return [];
  }

  try {
    const response = await accountApi.get(`users/email/${email}`);
    if (response?.status === 401 || response?.status === 402) {
      console.error(
        "Logged user does not have permission to view app users. Please ensure logged user is admin or has the permission read:users",
      );
      return [];
    }
    const data = response?.data;
    if (!data) return [];
    return Array.isArray(data) ? data : [data];
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getAllCochargeUsers = async () => {
  try {
    const response = await accountApi.get(`users/all`);
    return response?.data || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const addStationOwner = async (id, ownerEmail, role = "owner") => {
  try {
    const response = await accountApi.post("add-owner", {
      owner_email: ownerEmail,
      location_id: id,
      role,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addStationOwnerPermission = async (locationId) => {
  try {
    const response = await accountApi.post("add-permission", {
      location_id: locationId,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteStationOwner = async (id, ownerEmail) => {
  try {
    const response = await accountApi.post("delete-owner", {
      owner_email: ownerEmail,
      location_id: id,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getStationOwners = async (id) => {
  try {
    const response = await accountApi.get(`station-owners/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const acceptTermsForUser = async (userId, proofFile) => {
  try {
    const form = new FormData();
    form.append("proof", proofFile);
    const response = await accountApi.post(
      `users/${encodeURIComponent(userId)}/accept-terms-and-conditions`,
      form,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTermsAcceptanceAudit = async (userId) => {
  try {
    const response = await accountApi.get(
      `users/${encodeURIComponent(userId)}/terms-acceptance-audit`
    );
    return response.data || [];
  } catch (error) {
    console.error(error);
    throw error;
  }
};
